import { UseQueryResult } from '@tanstack/react-query'
import { Dispatch, SetStateAction } from 'react'

import { ShotlistsService } from '@/services/shotlist.service'

import { PLATFROMS_LANGUAGES } from '@/constants/languages'
import { IShotlist } from '@/types/shotlist.interface'
import { ILanguage } from '@/types/task.interface'
import { TPlatformValue } from '@/types/uploadForm.interface'

import { handleUploadTranslate } from './translate'

export const handleUploadTranscribe = async (
	taskId: string,
	language: string,
	selectedPlatform: TPlatformValue,
	selectedTranscribingLang: ILanguage,
	targetLanguage: string,
	setIsTranslating: Dispatch<SetStateAction<boolean>>,
	watchTaskUntilFinished: () => Promise<void>,
	handlers: {
		onTranslateStart: () => void
		onDone: (result: 'transcription' | 'translation') => void
		onError: (message?: string) => void
	},
	refetchShotlist?: UseQueryResult<IShotlist, unknown>['refetch']
): Promise<void> => {
	if (!taskId || !language || !selectedPlatform) return

	try {
		await ShotlistsService.updateShotlistLanguage(taskId, language)
		await ShotlistsService.transcribeShotlist(taskId)

		await watchTaskUntilFinished()

		const needsTranslate =
			PLATFROMS_LANGUAGES[selectedPlatform] !==
			selectedTranscribingLang.language

		if (!needsTranslate) {
			handlers.onDone('transcription')
			return
		}

		handlers.onTranslateStart()

		await refetchShotlist?.()

		await handleUploadTranslate(
			taskId,
			targetLanguage,
			selectedTranscribingLang.code,
			setIsTranslating,
			{
				onDone: () => handlers.onDone('translation'),
				onError: msg => handlers.onError(msg)
			}
		)
	} catch (error) {
		console.log(error)
		handlers.onError(error.message)
	}
}
